import * as React from 'react';
import release from './release.json';
import './DownloadPage.css';

export function DownloadPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = 'ดาวน์โหลด PkNiN : พีเคนินออนไลน์ สำหรับ Android';
    return () => { document.title = previous; };
  }, []);
  return <main className="apk-page" style={{ backgroundImage: "url('/assets/site/body.jpg')" }}>
    <div className="apk-page-glow" aria-hidden="true" />
    <header className="apk-header">
      <a href="/" className="apk-brand"><img src="/pknin-logo.png" alt="PKNiN" /><span>หมู่บ้านของเหล่านินจา</span></a>
      <a href="/" className="apk-home">กลับหน้าเว็บไซต์ ↗</a>
    </header>
    <section className="apk-hero">
      <div className="apk-intro">
        <span className="apk-eyebrow">PKNiN MOBILE · ANDROID</span>
        <h1>พกหมู่บ้านนินจา<br /><em>ไปกับคุณทุกที่</em></h1>
        <p>ผจญภัยกับตัวละครเดิมในแอป PKNiN เต็มจอแนวนอน พร้อมกลับเข้าสู่โลกนินจาได้ในสัมผัสเดียว</p>
        <div className="apk-features"><span>✦ บัญชีเกมเดิม</span><span>✦ เต็มจอแนวนอน</span><span>✦ ติดตั้งฟรี</span></div>
        <div className="apk-help">สำหรับ Android เท่านั้น · iPhone / iPad ยังเล่นผ่านเว็บไซต์ได้ตามปกติ</div>
      </div>
      <article className="apk-card" aria-label="ดาวน์โหลดแอป PKNiN">
        <span className="apk-beta">{release.label} · เปิดให้ทดลองเล่น</span>
        <img className="apk-card-logo" src="/pknin-logo.png" alt="โลโก้ PKNiN" />
        <h2>PkNiN : พีเคนินออนไลน์</h2>
        <p className="apk-card-note">ตำนานนินจาบทใหม่ เริ่มต้นที่นี่</p>
        <dl className="apk-specs"><div><dt>เวอร์ชัน</dt><dd>{release.version}</dd></div><div><dt>ขนาดไฟล์</dt><dd>{(release.bytes / 1000000).toFixed(1)} MB</dd></div><div><dt>รองรับ</dt><dd>Android {release.minimumAndroid}+</dd></div></dl>
        <a className="apk-download-button" href={release.url} download={release.fileName}>↓ ดาวน์โหลด APK <span>สำหรับ Android</span></a>
        <p className="apk-internet-note">ใช้บัญชีเดิมได้เลย · ต้องเชื่อมต่ออินเทอร์เน็ต</p>
        <p className="apk-internet-note">ผู้ใช้ Client รุ่น 0.3.x ติดตั้งทับได้เลย ส่วนแอปรุ่นเดิม 1.0.x จะติดตั้งแยกเป็นแอปใหม่ ใช้บัญชีเกมเดิมได้</p>
      </article>
    </section>
    <section className="apk-install" aria-labelledby="apk-install-title">
      <div className="apk-section-heading"><span>เตรียมตัวให้พร้อม</span><h2 id="apk-install-title">ติดตั้งง่าย ๆ ใน 3 ขั้นตอน</h2></div>
      <ol><li><b>01</b><h3>ดาวน์โหลดไฟล์</h3><p>กดปุ่มดาวน์โหลด APK แล้วเปิดไฟล์จากการแจ้งเตือนหรือโฟลเดอร์ดาวน์โหลดในมือถือ</p></li><li><b>02</b><h3>อนุญาตและติดตั้ง</h3><p>หาก Android ขอสิทธิ์ ให้เปิด “อนุญาตจากแหล่งนี้” สำหรับแอปที่ใช้เปิดไฟล์ แล้วกดติดตั้ง</p></li><li><b>03</b><h3>เข้าสู่หมู่บ้าน</h3><p>เปิดแอป PkNiN : พีเคนินออนไลน์ เข้าสู่ระบบด้วยบัญชีเกมเดิม หรือสมัครสมาชิกเพื่อเริ่มผจญภัย</p></li></ol>
    </section>
    <aside className="apk-assistance"><div><h3>ติดตั้งแล้วเปิดไม่ขึ้น?</h3><p>อัปเดต Android System WebView / Chrome ตรวจอินเทอร์เน็ต แล้วลองเข้าใหม่ รุ่นนี้อยู่ระหว่างทดสอบบนอุปกรณ์แต่ละรุ่น</p></div><a href="https://www.facebook.com/pknjth/" target="_blank" rel="noopener noreferrer">ติดต่อทีมงาน ↗</a></aside>
  </main>;
}
